/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.DataTable').directive('accInfiniteBodyScroll', [
    '$timeout', 'DATA_TABLE_EVENTS',
    function ($timeout, DATA_TABLE_EVENTS) {
        var ROW_HEIGHT = 52,
            DATA_TABLE_MIN_WIDTH = 768;

        return {
            link: function ($scope, $element) {
                var scrollingElement = $element.find('.scroller'),
                    wrapperElement = $element.find('div.wrapper'),
                    dataSectionElement = wrapperElement.find('#data');

                $scope.table.hasInfiniteScroll = true;

                _setElementsWidth();
                _setVisibleRows();

                $scope.$on('windowResize', function () {
                    _setVisibleRows();
                    _setElementsWidth();
                    _updateHorizontalScroll();
                    scrollingElement.perfectScrollbar('update');
                });

                $scope.$watch('table.filteredEntries.length', _setWrapperHeight);

                scrollingElement.on('ps-scroll-x', _updateHorizontalScroll);

                scrollingElement.scroll(function () {
                    $scope.table.rowsAboveVisible = _rowsAboveVisible();

                    if (_moreRowsToLoad() && _isCloseToTheEnd()) {
                        _loadTableRows();
                    }
                });

                function _updateHorizontalScroll() {
                    $('.data-table', dataSectionElement).css(
                        'transform',
                        'translate3d(-' + scrollingElement.prop('scrollLeft') + 'px, 0, 0)'
                    );
                }

                function _setWrapperHeight(itemsNum) {
                    wrapperElement.css('height', (Math.max(1, itemsNum) + 1) * ROW_HEIGHT);
                }

                function _setElementsWidth() {
                    $timeout(function () {
                        var width = Math.max(
                            DATA_TABLE_MIN_WIDTH,
                            scrollingElement.width(),
                            ($('.table', dataSectionElement).width() || 0) + 30
                        );
                        wrapperElement.css('width', width);
                        dataSectionElement.css('width', width - 30);

                        $scope.$broadcast(DATA_TABLE_EVENTS.SET_WIDTH);
                    }, 300);
                }

                function _setVisibleRows() {
                    $scope.table.visibleRows = Math.ceil(scrollingElement.height() / ROW_HEIGHT) + 2; // a couple more just in case
                }

                function _moreRowsToLoad() {
                    return _getTableRows().length < _getTablePagination().getTotal();
                }

                function _rowsAboveVisible() {
                    return Math.ceil(scrollingElement.scrollTop() / ROW_HEIGHT);
                }

                function _loadTableRows() {
                    $scope.table.loadMore();
                }

                function _getTableRows() {
                    return $scope.table.entries;
                }

                function _getTablePagination() {
                    return $scope.table.pagination;
                }

                function _isCloseToTheEnd() {
                    let totalHeight = wrapperElement.height();
                    let nativeScrollingElement = scrollingElement[0];
                    let scrollPosition = nativeScrollingElement.scrollTop + nativeScrollingElement.clientHeight;
                    let offset = ROW_HEIGHT * 25;

                    return scrollPosition + offset > totalHeight;
                }
            }
        };
    }
]);
